/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOutbox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.002 4v2H7.235l-3.23 6h4.533l2 3h2.929l2-3h6.515L22 13.02V22H2.005l-.001-9.37a10.963 10.963 0 0 1 0-.586v-.025L2.006 12 6.11 4.553A1 1 0 0 1 7.004 4zM7.468 14H4.004v6H20v-6h-3.464l-2 3H9.469zM22 2v6h-2V5.414l-4.291 4.293-1.414-1.414L18.585 4H16V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgOutbox as Outbox };
